module.exports = __webpack_public_path__ + "img/Check-big.33217c9f.svg";